import { render, staticRenderFns } from "./animated-number.component.vue?vue&type=template&id=3ba9532d&scoped=true"
import script from "./animated-number.component.vue?vue&type=script&lang=js"
export * from "./animated-number.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba9532d",
  null
  
)

export default component.exports